import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "turbo-elementor-widgets"
    }}>{`Turbo Elementor Widgets`}</h1>
    <p>{`All the turbo elementor widgets are available below.`}</p>
    <p><img alt="introElementor.png" src={require("./images/elementor-widgets/introElementor.png")} /></p>
    <h2 {...{
      "id": "intro"
    }}>{`Intro`}</h2>
    <p>{`To get the full experience of Turbo elementor there are some plugins required in the Wordpress.`}</p>
    <p>{`Those are:`}</p>
    <ul>
      <li parentName="ul">{`Turbo Helper`}</li>
      <li parentName="ul">{`WooCommerce Rental & Bookings`}</li>
      <li parentName="ul">{`Inspect`}</li>
      <li parentName="ul">{`Turbo Manager`}</li>
      <li parentName="ul">{`Elementor`}</li>
      <li parentName="ul">{`WooCommerce - excelling eCommerce`}</li>
      <li parentName="ul">{`Load Gooogle Map`}</li>
    </ul>
    <h2 {...{
      "id": "car-tabs"
    }}>{`Car Tabs`}</h2>
    <h3 {...{
      "id": "widget-settings-layout-1--2"
    }}>{`Widget Settings Layout 1 & 2:`}</h3>
    <p><img alt="cartabsLayout1Back.png" src={require("./images/elementor-widgets/cartabsLayout1Back.png")} />{` `}<img alt="cartabsLayout2Back.png" src={require("./images/elementor-widgets/cartabsLayout2Back.png")} /></p>
    <h3 {...{
      "id": "layout-1-frontend"
    }}>{`Layout 1 FrontEnd:`}</h3>
    <p><img alt="cartabsFrontLayout1.png" src={require("./images/elementor-widgets/cartabsFrontLayout1.png")} /></p>
    <h3 {...{
      "id": "layout-2-frontend"
    }}>{`Layout 2 FrontEnd:`}</h3>
    <p><img alt="cartabsFrontLayout2.png" src={require("./images/elementor-widgets/cartabsFrontLayout2.png")} /></p>
    <h2 {...{
      "id": "content-blocks"
    }}>{`Content Blocks`}</h2>
    <h3 {...{
      "id": "widget-settings"
    }}>{`Widget settings:`}</h3>
    <p><img alt="contentBlockBack.png" src={require("./images/elementor-widgets/contentBlockBack.png")} /></p>
    <h3 {...{
      "id": "default-layout-frontend"
    }}>{`Default Layout FrontEnd:`}</h3>
    <p><img alt="contentBlockDeault.png" src={require("./images/elementor-widgets/contentBlockDeault.png")} /></p>
    <h3 {...{
      "id": "alternative-layout-frontend"
    }}>{`Alternative Layout FrontEnd:`}</h3>
    <p><img alt="contentBlockAlternative.png" src={require("./images/elementor-widgets/contentBlockAlternative.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Note: There are different layout select option available in widget settings.`}</p>
    </blockquote>
    <h2 {...{
      "id": "featured-blocks"
    }}>{`Featured Blocks`}</h2>
    <h3 {...{
      "id": "widget-settings-1"
    }}>{`Widget Settings`}</h3>
    <h4 {...{
      "id": "layout-1"
    }}>{`Layout 1`}</h4>
    <p><img alt="featuredBlockLayout1Back.png" src={require("./images/elementor-widgets/featuredBlockLayout1Back.png")} />{` `}</p>
    <h4 {...{
      "id": "layout-2"
    }}>{`Layout 2`}</h4>
    <p><img alt="featuredBlockLayout2Back.png" src={require("./images/elementor-widgets/featuredBlockLayout2Back.png")} />{` `}</p>
    <h4 {...{
      "id": "layout-3"
    }}>{`Layout 3`}</h4>
    <p><img alt="featuredBlockLayout3Back.png" src={require("./images/elementor-widgets/featuredBlockLayout3Back.png")} />{` `}</p>
    <h4 {...{
      "id": "layout-4"
    }}>{`Layout 4`}</h4>
    <p><img alt="featuredBlockLayout4Back.png" src={require("./images/elementor-widgets/featuredBlockLayout4Back.png")} />{` `}</p>
    <h3 {...{
      "id": "frontend"
    }}>{`FrontEnd:`}</h3>
    <h4 {...{
      "id": "layout-1-1"
    }}>{`Layout 1`}</h4>
    <p><img alt="featuredBlockLayout1Front.png" src={require("./images/elementor-widgets/featuredBlockLayout1Front.png")} /></p>
    <h4 {...{
      "id": "layout-2-1"
    }}>{`Layout 2`}</h4>
    <p><img alt="featuredBlockLayout2Front.png" src={require("./images/elementor-widgets/featuredBlockLayout2Front.png")} /></p>
    <h4 {...{
      "id": "layout-3-1"
    }}>{`Layout 3`}</h4>
    <p><img alt="featuredBlockLayout3Front.png" src={require("./images/elementor-widgets/featuredBlockLayout3Front.png")} /></p>
    <h4 {...{
      "id": "layout-4-1"
    }}>{`Layout 4`}</h4>
    <p><img alt="featuredBlockLayout4Front.png" src={require("./images/elementor-widgets/featuredBlockLayout4Front.png")} /></p>
    <h2 {...{
      "id": "recent-products"
    }}>{`Recent Products`}</h2>
    <h3 {...{
      "id": "widget-settings-2"
    }}>{`Widget Settings:`}</h3>
    <p><img alt="recentProductsLayoutBack.png" src={require("./images/elementor-widgets/recentProductsLayoutBack.png")} /></p>
    <h3 {...{
      "id": "frontend-1"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="recentProductsLayout1Front.png" src={require("./images/elementor-widgets/recentProductsLayout1Front.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Note: There are different layout select option available in widget settings.`}</p>
    </blockquote>
    <h2 {...{
      "id": "testimonial"
    }}>{`Testimonial`}</h2>
    <h3 {...{
      "id": "backend"
    }}>{`Backend:`}</h3>
    <p><img alt="testimonialDashBack.png" src={require("./images/elementor-widgets/testimonialDashBack.png")} /></p>
    <h3 {...{
      "id": "widget-setting"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="testimonialLayoutBack.png" src={require("./images/elementor-widgets/testimonialLayoutBack.png")} /></p>
    <h3 {...{
      "id": "frontend-2"
    }}>{`FrontEnd:`}</h3>
    <h4 {...{
      "id": "layout-1-2"
    }}>{`Layout 1`}</h4>
    <p><img alt="testimonialLayout1Front.png" src={require("./images/elementor-widgets/testimonialLayout1Front.png")} /></p>
    <h4 {...{
      "id": "layout-2-2"
    }}>{`Layout 2`}</h4>
    <p><img alt="testimonialLayout2Front.png" src={require("./images/elementor-widgets/testimonialLayout2Front.png")} /></p>
    <h4 {...{
      "id": "layout-3-2"
    }}>{`Layout 3`}</h4>
    <p><img alt="testimonialLayout3Front.png" src={require("./images/elementor-widgets/testimonialLayout3Front.png")} /></p>
    <h2 {...{
      "id": "tips--tricks"
    }}>{`Tips & Tricks`}</h2>
    <h3 {...{
      "id": "backend-1"
    }}>{`Backend:`}</h3>
    <p><img alt="tipsAndTricksDashBack.png" src={require("./images/elementor-widgets/tipsAndTricksDashBack.png")} /></p>
    <h3 {...{
      "id": "widget-setting-1"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="tipsAndTricksBack.png" src={require("./images/elementor-widgets/tipsAndTricksBack.png")} /></p>
    <h3 {...{
      "id": "frontend-3"
    }}>{`FrontEnd:`}</h3>
    <h4 {...{
      "id": "default-layout"
    }}>{`Default Layout`}</h4>
    <p><img alt="tipsAndTricksFront.png" src={require("./images/elementor-widgets/tipsAndTricksFront.png")} /></p>
    <h4 {...{
      "id": "alternative-layout"
    }}>{`Alternative Layout`}</h4>
    <p><img alt="tipsAndTricksAlternativeFront.png" src={require("./images/elementor-widgets/tipsAndTricksAlternativeFront.png")} /></p>
    <h2 {...{
      "id": "help-line"
    }}>{`Help Line`}</h2>
    <h3 {...{
      "id": "widget-setting-2"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="helpLineBack.png" src={require("./images/elementor-widgets/helpLineBack.png")} /></p>
    <h3 {...{
      "id": "frontend-4"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="helpLineFront.png" src={require("./images/elementor-widgets/helpLineFront.png")} /></p>
    <h2 {...{
      "id": "our-mission"
    }}>{`Our Mission`}</h2>
    <h3 {...{
      "id": "widget-setting-3"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="ourMissionBack.png" src={require("./images/elementor-widgets/ourMissionBack.png")} /></p>
    <h3 {...{
      "id": "frontend-5"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="ourMissionFront.png" src={require("./images/elementor-widgets/ourMissionFront.png")} /></p>
    <h2 {...{
      "id": "our-partner"
    }}>{`Our Partner`}</h2>
    <h3 {...{
      "id": "widget-setting-4"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="partnerBlockBack.png" src={require("./images/elementor-widgets/partnerBlockBack.png")} /></p>
    <h3 {...{
      "id": "frontend-6"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="partnerBlockFront.png" src={require("./images/elementor-widgets/partnerBlockFront.png")} /></p>
    <h2 {...{
      "id": "search-form"
    }}>{`Search Form`}</h2>
    <h3 {...{
      "id": "backend-2"
    }}>{`Backend:`}</h3>
    <p><img alt="searchFormDashBack.png" src={require("./images/elementor-widgets/searchFormDashBack.png")} /></p>
    <h3 {...{
      "id": "widget-setting-5"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="searchFormBack.png" src={require("./images/elementor-widgets/searchFormBack.png")} /></p>
    <h4 {...{
      "id": "vertical-search-form"
    }}>{`Vertical Search Form`}</h4>
    <p><img alt="searchFormVerticalFront.png" src={require("./images/elementor-widgets/searchFormVerticalFront.png")} /></p>
    <h4 {...{
      "id": "horizontal-search-form"
    }}>{`Horizontal Search Form`}</h4>
    <p><img alt="searchFormHorizontalFront.png" src={require("./images/elementor-widgets/searchFormHorizontalFront.png")} /></p>
    <h2 {...{
      "id": "about-contact-info"
    }}>{`About Contact Info`}</h2>
    <h3 {...{
      "id": "widget-setting-6"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="aboutContactBack.png" src={require("./images/elementor-widgets/aboutContactBack.png")} /></p>
    <h3 {...{
      "id": "frontend-7"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="aboutContactFront.png" src={require("./images/elementor-widgets/aboutContactFront.png")} /></p>
    <h2 {...{
      "id": "the-brand"
    }}>{`The Brand`}</h2>
    <h3 {...{
      "id": "widget-setting-7"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="theBrandsBack.png" src={require("./images/elementor-widgets/theBrandsBack.png")} /></p>
    <h3 {...{
      "id": "frontend-8"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="theBrandsFront.png" src={require("./images/elementor-widgets/theBrandsFront.png")} /></p>
    <h2 {...{
      "id": "contact-details"
    }}>{`Contact details`}</h2>
    <h3 {...{
      "id": "widget-setting-8"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="contactAddressBarBack.png" src={require("./images/elementor-widgets/contactAddressBarBack.png")} /></p>
    <h3 {...{
      "id": "frontend-9"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="contactAddressBarFront.png" src={require("./images/elementor-widgets/contactAddressBarFront.png")} /></p>
    <h2 {...{
      "id": "featured-product"
    }}>{`Featured Product`}</h2>
    <h3 {...{
      "id": "widget-setting-9"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="featuredProductBack.png" src={require("./images/elementor-widgets/featuredProductBack.png")} /></p>
    <h3 {...{
      "id": "frontend-10"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="featuredProductFront.png" src={require("./images/elementor-widgets/featuredProductFront.png")} /></p>
    <h2 {...{
      "id": "download-app"
    }}>{`Download App`}</h2>
    <h3 {...{
      "id": "widget-setting-10"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="downloadAppBack.png" src={require("./images/elementor-widgets/downloadAppBack.png")} /></p>
    <h3 {...{
      "id": "frontend-11"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="downloadApp.png" src={require("./images/elementor-widgets/downloadApp.png")} /></p>
    <h2 {...{
      "id": "single-content-block"
    }}>{`Single Content Block`}</h2>
    <h3 {...{
      "id": "widget-setting-11"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="singleContentBlockBack.png" src={require("./images/elementor-widgets/singleContentBlockBack.png")} /></p>
    <h3 {...{
      "id": "frontend-12"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="singleContentBlockFront.png" src={require("./images/elementor-widgets/singleContentBlockFront.png")} /></p>
    <h2 {...{
      "id": "button"
    }}>{`Button`}</h2>
    <h3 {...{
      "id": "widget-setting-12"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="buttonBack.png" src={require("./images/elementor-widgets/buttonBack.png")} /></p>
    <h3 {...{
      "id": "frontend-13"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="buttonFront.png" src={require("./images/elementor-widgets/buttonFront.png")} /></p>
    <h2 {...{
      "id": "countdown"
    }}>{`CountDown`}</h2>
    <h3 {...{
      "id": "widget-setting-13"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="countdownBack.png" src={require("./images/elementor-widgets/countdownBack.png")} /></p>
    <h3 {...{
      "id": "frontend-14"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="countdown.png" src={require("./images/elementor-widgets/countdown.png")} /></p>
    <h2 {...{
      "id": "progress-bar"
    }}>{`Progress Bar`}</h2>
    <h3 {...{
      "id": "widget-setting-14"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="progressbarBack.png" src={require("./images/elementor-widgets/progressbarBack.png")} /></p>
    <h4 {...{
      "id": "linear-frontend"
    }}>{`Linear FrontEnd`}</h4>
    <p><img alt="progressbar.png" src={require("./images/elementor-widgets/progressbar.png")} /></p>
    <h4 {...{
      "id": "circular-frontend"
    }}>{`Circular FrontEnd`}</h4>
    <p><img alt="progressbarCircle.png" src={require("./images/elementor-widgets/progressbarCircle.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Note: There are different layout options available in the widget settings.`}</p>
    </blockquote>
    <h2 {...{
      "id": "accordions"
    }}>{`Accordions`}</h2>
    <h3 {...{
      "id": "widget-setting-15"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="accordionBack.png" src={require("./images/elementor-widgets/accordionBack.png")} /></p>
    <h3 {...{
      "id": "frontend-15"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="accordionFront.png" src={require("./images/elementor-widgets/accordionFront.png")} /></p>
    <h2 {...{
      "id": "google-map"
    }}>{`Google Map`}</h2>
    <h3 {...{
      "id": "widget-setting-16"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="googleMapBack.png" src={require("./images/elementor-widgets/googleMapBack.png")} /></p>
    <h3 {...{
      "id": "frontend-16"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="googleMap.png" src={require("./images/elementor-widgets/googleMap.png")} /></p>
    <h2 {...{
      "id": "fancy-title"
    }}>{`Fancy Title`}</h2>
    <h3 {...{
      "id": "widget-setting-17"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="fancyTitleDefaultBack.png" src={require("./images/elementor-widgets/fancyTitleDefaultBack.png")} />{` `}<img alt="fancyTitleAlternativeBack.png" src={require("./images/elementor-widgets/fancyTitleAlternativeBack.png")} /></p>
    <h3 {...{
      "id": "frontend-17"
    }}>{`FrontEnd:`}</h3>
    <h4 {...{
      "id": "layout-1-3"
    }}>{`Layout 1`}</h4>
    <p><img alt="fancyTitleDefault.png" src={require("./images/elementor-widgets/fancyTitleDefault.png")} /></p>
    <h4 {...{
      "id": "layout-2-3"
    }}>{`Layout 2`}</h4>
    <p><img alt="fancyTitleAlternative.png" src={require("./images/elementor-widgets/fancyTitleAlternative.png")} /></p>
    <h2 {...{
      "id": "search-result"
    }}>{`Search Result`}</h2>
    <p>{`First you have to create search result in inspect builder.
Inspect builder > Add new > Select search result in the dropdown menu > Publish
Then you have to select Listing Page from inspect setting on dashboard.`}</p>
    <h3 {...{
      "id": "backend-3"
    }}>{`Backend:`}</h3>
    <p><img alt="listingDash.png" src={require("./images/elementor-widgets/listingDash.png")} /></p>
    <h3 {...{
      "id": "widget-setting-18"
    }}>{`Widget Setting:`}</h3>
    <p><img alt="searchResultBack.png" src={require("./images/elementor-widgets/searchResultBack.png")} /></p>
    <h3 {...{
      "id": "frontend-18"
    }}>{`FrontEnd:`}</h3>
    <p><img alt="searchResultFront.png" src={require("./images/elementor-widgets/searchResultFront.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      